// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ForecastTabs_tabsWrapper__lZSAn {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  gap: 6px;
}

.ForecastTabs_tabs__bPAu\\+ {
  display: flex;
  gap: 6px;
  flex: 1 1;
  justify-content: center;
  overflow: hidden;
}

/* Кнопки табов */
.ForecastTabs_tab__LKDjP {
  background: rgba(255, 255, 255, 0.07);
  color: #ccc;
  font-size: 13px;
  font-weight: 500;
  border: none;
  border-radius: 14px;
  padding: 10px 10px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  min-width: 90px;
  flex-shrink: 0;
}

.ForecastTabs_active__1hRj7 {
  background: #5b2a85;
  color: #fff;
}

.ForecastTabs_arrowButton__ftN6h {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.2s;
}

.ForecastTabs_tabContent__OsuNn {
  width: 100%;
}

/* ---- Мобайл стили ---- */
@media (max-width: 470px) {
  .ForecastTabs_tabsWrapper__lZSAn {
    gap: 0;
  }
  .ForecastTabs_tabs__bPAu\\+ {
    min-width: 0;
    flex: 1 1 auto;
    gap: 4px;
    overflow: hidden;
  }
  .ForecastTabs_tab__LKDjP {
    padding: 8px 4px;
    font-size: 16px;
    min-width: 60px;
    flex-basis: 0;
    flex-grow: 1;
    flex-shrink: 1;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Forecast/sections/ForecastTabs.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,SAAO;EACP,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,qCAAqC;EACrC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,uCAAuC;EACvC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE;IACE,MAAM;EACR;EACA;IACE,YAAY;IACZ,cAAc;IACd,QAAQ;IACR,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,aAAa;IACb,YAAY;IACZ,cAAc;IACd,kBAAkB;EACpB;AACF","sourcesContent":[".tabsWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 16px;\n  gap: 6px;\n}\n\n.tabs {\n  display: flex;\n  gap: 6px;\n  flex: 1;\n  justify-content: center;\n  overflow: hidden;\n}\n\n/* Кнопки табов */\n.tab {\n  background: rgba(255, 255, 255, 0.07);\n  color: #ccc;\n  font-size: 13px;\n  font-weight: 500;\n  border: none;\n  border-radius: 14px;\n  padding: 10px 10px;\n  cursor: pointer;\n  transition: background 0.2s, color 0.2s;\n  min-width: 90px;\n  flex-shrink: 0;\n}\n\n.active {\n  background: #5b2a85;\n  color: #fff;\n}\n\n.arrowButton {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: background 0.2s;\n}\n\n.tabContent {\n  width: 100%;\n}\n\n/* ---- Мобайл стили ---- */\n@media (max-width: 470px) {\n  .tabsWrapper {\n    gap: 0;\n  }\n  .tabs {\n    min-width: 0;\n    flex: 1 1 auto;\n    gap: 4px;\n    overflow: hidden;\n  }\n  .tab {\n    padding: 8px 4px;\n    font-size: 16px;\n    min-width: 60px;\n    flex-basis: 0;\n    flex-grow: 1;\n    flex-shrink: 1;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabsWrapper": `ForecastTabs_tabsWrapper__lZSAn`,
	"tabs": `ForecastTabs_tabs__bPAu+`,
	"tab": `ForecastTabs_tab__LKDjP`,
	"active": `ForecastTabs_active__1hRj7`,
	"arrowButton": `ForecastTabs_arrowButton__ftN6h`,
	"tabContent": `ForecastTabs_tabContent__OsuNn`
};
export default ___CSS_LOADER_EXPORT___;
